import { isEmpty } from 'lodash'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import Loader from 'components/Loader'
import Section from 'components/Section'
import RevenueCenterItem from 'components/RevenueCenters/RevenueCenterItem'
import RevenueCentersDetailsPage from 'pages/RevenueCentersDetails'

import {
  getIsLoadingAvailability,
  getIsRevenueCentersLoading,
} from 'store/RevenueCenters/selector'
import { getIsMenusLoading } from 'store/Menus/selectors'

const RevenueCentersList = ({ revenueCentersList }) => {
  const { state: locationState } = useLocation()

  const isModal = !isEmpty(locationState?.revenueCenterUuid)

  const isLoadingRevenueCenters = useSelector(
    getIsRevenueCentersLoading
  )
  const isLoadingMenus = useSelector(getIsMenusLoading)
  const isLoadingAvailability = useSelector(getIsLoadingAvailability)

  const isLoading =
    (isLoadingRevenueCenters ||
      isLoadingMenus ||
      isLoadingAvailability) &&
    !isModal

  if (isLoading) {
    return <Loader />
  }
  return (
    <>
      <Section className="item-list">
        {revenueCentersList?.map(({ name, uuid, id }) => (
          <RevenueCenterItem
            name={name}
            id={id}
            key={uuid}
            uuid={uuid}
          />
        ))}
      </Section>
      {isModal && <RevenueCentersDetailsPage />}
    </>
  )
}

export default RevenueCentersList
